import React from 'react'
import PropTypes from 'prop-types'
import { Stack, Button } from '@mui/material'

const FormModalCustomActionBar = ({ buttonConfigs, justify }) => (
  <Stack
    direction="row"
    justifyContent={justify}
    p={2}
    spacing={2}
    sx={{
      boxShadow:
        '0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px rgba(0, 0, 0, 0.14), 0px 1px 8px rgba(0, 0, 0, 0.12)',
    }}
  >
    {buttonConfigs.map((button, i) => (
      <Button key={button.id || i} {...button}>
        {button.text}
      </Button>
    ))}
  </Stack>
)

FormModalCustomActionBar.propTypes = {
  buttonConfigs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      text: PropTypes.node.isRequired,
      type: PropTypes.string,
      onClick: PropTypes.func,
    }),
  ).isRequired,
  justify: PropTypes.oneOf(['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'space-evenly']),
}

FormModalCustomActionBar.defaultProps = {
  justify: 'space-between',
}

export default FormModalCustomActionBar
